import React from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { formTypes } from "../../components/UI/form";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { ModalTemplate, ModalFields } from "../UI/modalComponents";
import BaseModal from "./baseModal/BaseModal";
import {
  DROPDOWN,
  STRING_INPUT,
  GET_HTML,
  SELECT_MULTIPLE_DROPDOWN
} from "./baseModal/FieldTypes";
import { notEmptyString } from "./baseModal/validators";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
class AddResourcesModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
      programs: [],
      online: [],
      users: [],
      users_picked: [],
      programs_picked: [],
      online_picked: [],
      type: "",
      module: ""
    };
  }

  async componentDidMount() {
    const ep = `${process.env.REACT_APP_API}/partners/programs/list`;
    const ep2 = `${process.env.REACT_APP_API}/partners/roles`;
    const ep3 = `${process.env.REACT_APP_API}/partners/virtual/list`;
    const results = await axios.get(ep);
    const users = await axios.get(ep2);
    const online = await axios.get(ep3);
    if (results.data.success) {
      const options = [];
      users.data.data.users.map(u => {
        if (u.username) {
          options.push({
            label: u.username,
            value: u.id
          });
        }
      });

      this.setState({
        options: options,
        programs: results.data.data.filter(f => !f.isArchived),
        users: users.data.data.users,
        online: online.data.data.filter(f => !f.isArchived)
      });
      console.log("this.state.users", this.state.users);
      console.log("this.state.programs", this.state.programs);
      console.log("this.state.online", this.state.online);
    }
  }
  async addNewResource(e) {
    e.preventDefault();
    const ep = `${process.env.REACT_APP_API}/partners/resources/save`;
    const obj = {
      module: this.state.module,
      access: this.state.users_picked.map(e => e.value),
      programs: this.state.programs_picked.map(e => e.value),
      online: this.state.online_picked.map(e => e.value),
      resource_type: this.state.type
    };

    const result = await axios.post(ep, obj);
    if (result.data.success) {
      this.props.onAdd();
      toast.success(`Modules Added!`);
      this.props.onClose();
    }
  }
  requestTour = async e => {
    e.preventDefault();
  };

  /// ================== NEW MODAL ========================== ///

  getallContent = () => {
    console.log("this.state.users", this.state.users);
    return (
      <div>
        {this.state.type === "Program" && (
          <div>
            <label
              htmlFor="displayName"
              style={{
                width: "25%",
                textAlign: "left",
                fontSize: "1.15rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "500",
                color: "#626262"
              }}
            >
              Program
            </label>
            <div
              style={{
                width: "100%",
                marginBottom: "22px"
              }}
            >
              <formTypes.UserDropDown
                style={{
                  height: "40px",
                  width: "100%",
                  fontSize: "0.93rem",
                  fontFamily: "futura-pt, sans-serif",
                  fontWeight: "400",
                  color: "#797979",
                  border: "1px solid #c5c5c5",
                  borderRadius: "4px",
                  paddingLeft: "14px",
                  marginBottom: "22px"
                }}
                value={this.state.programs_picked}
                options={[
                  ...this.state.programs.map(u => ({
                    name: u.program_name,
                    value: u.id
                  }))
                ]}
                onChange={(_, v) =>
                  this.setState({
                    programs_picked: v
                  })
                }
                searchable
                searchBy="name"
              />
            </div>
          </div>
        )}
        {this.state.type === "Online" && (
          <div>
            <label
              htmlFor="displayName"
              style={{
                width: "25%",
                textAlign: "left",
                fontSize: "1.15rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "500",
                color: "#626262"
              }}
            >
              Online
            </label>
            <div
              style={{
                width: "100%",
                marginBottom: "22px"
              }}
            >
              <formTypes.UserDropDown
                style={{
                  height: "40px",
                  width: "100%",
                  fontSize: "0.93rem",
                  fontFamily: "futura-pt, sans-serif",
                  fontWeight: "400",
                  color: "#797979",
                  border: "1px solid #c5c5c5",
                  borderRadius: "4px",
                  paddingLeft: "14px"
                }}
                value={this.state.online_picked}
                options={[
                  ...this.state.online.map(u => ({
                    name: u.program_name,
                    value: u.id
                  }))
                ]}
                onChange={(_, v) =>
                  this.setState({
                    online_picked: v
                  })
                }
                searchable
                searchBy="name"
              />
            </div>
          </div>
        )}
        <div>
          <label
            htmlFor="displayName"
            style={{
              width: "25%",
              textAlign: "left",
              fontSize: "1.15rem",
              fontFamily: "futura-pt, sans-serif",
              fontWeight: "500",
              color: "#626262"
            }}
          >
            Access
          </label>
          <div
            style={{
              width: "100%"
            }}
          >
            <formTypes.UserDropDown
              style={{
                height: "40px",
                width: "100%",
                fontSize: "0.93rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "400",
                color: "#797979",
                border: "1px solid #c5c5c5",
                borderRadius: "4px",
                paddingLeft: "14px"
              }}
              value={this.state.users_picked}
              options={[
                ...this.state.users
                  .filter(f => f.sub_user)
                  .map(u => ({
                    name: u.username,
                    value: u.id
                  }))
              ]}
              onChange={(_, v) => {
                console.log("v", v);
                this.setState({
                  users_picked: v
                });
              }}
              dropdownPosition="top"
            />
          </div>
        </div>
      </div>
    );
  };

  programOptions = () => {
    return [
      ...this.state.programs.map(({ id, program_name }) => ({
        value: id,
        text: program_name
      }))
    ];
  };

  onlineOptions = () => {
    return [
      ...this.state.online.map(({ id, program_name }) => ({
        value: id,
        text: program_name
      }))
    ];
  };

  accessOptions = () => {
    return [
      ...this.state.users
        .filter(f => f.id != f.partner_id)
        .map(({ id, username }) => ({
          value: id,
          text: username
        }))
    ];
  };

  getBaseModalFields() {
    const descriptionInput = {
      type: STRING_INPUT,
      data: {
        name: "Module Name",
        required: true,
        placeholder: "Module's name...",
        handleChange: e => {
          this.setState({
            module: e.target.value
          });
        },
        value: this.state.module
      },
      validators: { validateSubmit: notEmptyString(this.state.module) }
    };

    const typeInput = {
      type: DROPDOWN,
      data: {
        name: "Type",
        required: false,
        placeholder: "Please Select",
        handleChange: e => {
          this.setState({
            type: e.currentTarget.value
          });
        },
        choices: [
          { value: "Program", text: "Program" },
          { value: "Online", text: "Online" }
        ]
      }
    };

    /*     const accessInput = {
      type: SELECT_MULTIPLE_DROPDOWN,
      data: {
        name: "Access",
        required: false,
        placeholder: "Please Select",
        value: this.state.users_picked,
        handleChange: e => {
          console.log("e", e);
          this.setState({
            users_picked: e
          });
        },
        choices: this.accessOptions()
      } 
    };
 */
    const getContentInput = {
      type: GET_HTML,
      data: {
        gethtml: this.getallContent
      }
    };

    /*   if (this.state.type === "Program") {
      const programtypeInput = {
        type: SELECT_MULTIPLE_DROPDOWN,
        data: {
          name: "Program",
          required: false,
          placeholder: "Please Select",
          value: this.state.programs_picked,
          handleChange: e =>
            this.setState({
              programs_picked: e
            }),
          choices: this.programOptions()
        } 
      };
      return [descriptionInput, typeInput, programtypeInput, accessInput];
    } else if (this.state.type === "Online") {
      const programtypeInput = {
        type: SELECT_MULTIPLE_DROPDOWN,
        data: {
          name: "Online",
          required: false,
          placeholder: "Please Select",
          value: this.state.online_picked,
          handleChange: e =>
            this.setState({
              online_picked: e
            }),
          choices: this.onlineOptions()
        } 
      };
      return [descriptionInput, typeInput, programtypeInput, accessInput];
    } */

    const fields = [];
    fields.push(descriptionInput);
    fields.push(typeInput);
    fields.push(getContentInput);

    return fields;
  }

  getBaseModalButtons = () => {
    const addButton = {
      name: "Add New Module",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatorKey: "validateSubmit",
      handleClick: e => this.addNewResource(e)
    };

    return [addButton];
  };

  getBaseModalProps = () => {
    return {
      title: "Add Resource Module",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "52vh",
      handleClose: this.props.onClose
    };
  };

  /// ================== END NEW MODAL ===================== ///

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
    return (
      <ModalTemplate heading="Add Resource Module" onClose={this.props.onClose}>
        <form onSubmit={e => this.addNewResource(e)}>
          <div className="modal-main">
            <ModalFields.input
              label="Module Name"
              name="module"
              required={true}
              type="text"
              placeholder="Module's name..."
              onChange={e => {
                this.setState({
                  module: e.target.value
                });
              }}
              value={this.state.module}
            />
            <ModalFields.custom label="Type" name="type">
              <select
                onChange={e => this.setState({ type: e.currentTarget.value })}
                id="type"
                className="form-control"
                style={{ width: "70%" }}
              >
                <option value="" selected disabled hidden>
                  Choose here
                </option>
                <option value="Program">Program</option>
                <option value="Online">Online</option>
              </select>
            </ModalFields.custom>
            {this.state.type === "Program" && (
              <ModalFields.custom label="Program" name="program">
                <div style={{ width: "70%" }}>
                  <formTypes.UserDropDown
                    value={this.state.programs_picked}
                    options={[
                      ...this.state.programs.map(u => ({
                        name: u.program_name,
                        value: u.id
                      }))
                    ]}
                    onChange={(_, v) =>
                      this.setState({
                        programs_picked: v
                      })
                    }
                  />
                </div>
              </ModalFields.custom>
            )}
            {this.state.type === "Online" && (
              <ModalFields.custom label="Online" name="online">
                <div style={{ width: "70%" }}>
                  <formTypes.UserDropDown
                    value={this.state.online_picked}
                    options={[
                      ...this.state.online.map(u => ({
                        name: u.program_name,
                        value: u.id
                      }))
                    ]}
                    onChange={(_, v) =>
                      this.setState({
                        online_picked: v
                      })
                    }
                  />
                </div>
              </ModalFields.custom>
            )}
            <ModalFields.custom label="Access" name="access">
              <div style={{ width: "70%" }}>
                <formTypes.UserDropDown
                  value={this.state.users_picked}
                  options={[
                    ...this.state.users.map(u => ({
                      name: u.username,
                      value: u.id
                    }))
                  ]}
                  onChange={(_, v) => {
                    console.log("v", v);
                    this.setState({
                      users_picked: v
                    });
                  }}
                  dropdownPosition="top"
                />
              </div>
            </ModalFields.custom>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn">
              Add New Module
            </button>
          </div>
        </form>
      </ModalTemplate>
    );
  }
}

export default withRouter(AddResourcesModal);
